import axios from "axios";
import { toast } from "react-hot-toast";

/* ================================
   ACTION TYPES
================================ */
export const CREATE_KITCHEN_REQUEST = "CREATE_KITCHEN_REQUEST";
export const CREATE_KITCHEN_SUCCESS = "CREATE_KITCHEN_SUCCESS";
export const CREATE_KITCHEN_FAILURE = "CREATE_KITCHEN_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createKitchen = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_KITCHEN_REQUEST });

  try {
    const res = await axios.post(
      `${BASE_URL}/api/maa_canteen/kitchen/add`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: CREATE_KITCHEN_SUCCESS,
      payload: res.data.data,
    });

    toast.success("Kitchen created successfully");

    return res.data; // ✅ enables navigation after success
  } catch (error) {
    dispatch({
      type: CREATE_KITCHEN_FAILURE,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message,
    });

    toast.error("Failed to create kitchen");
    throw error;
  }
};
